import { render, staticRenderFns } from "./resume-moving-regions-view.vue?vue&type=template&id=382ef965&"
import script from "./resume-moving-regions-view.vue?vue&type=script&lang=js&"
export * from "./resume-moving-regions-view.vue?vue&type=script&lang=js&"
import style0 from "./resume-moving-regions-view.vue?vue&type=style&index=0&id=382ef965&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports